export default __webpack_public_path__ + "img/2e1c11cc17a61db6fc8b576bbf844f85.svg";